module.exports = __webpack_public_path__ + "img/golden_dream.6ae5b851.jpg";